import React from "react";
import { TableRow, TableCell } from "@mui/material";
import { ROW_HEIGHT, TRANSLATION_Y_OFFSET, CONNECTOR_TRANSITION_BASE_DELAY } from "./RfqConstants";
import RfqActionButtons from "./RfqActionButtons";
// import { ORDER_STATUS } from "../../../Constants/AppConstants"; // removed unused
import { tokens } from "../../../Common/designTokens";

const RfqTableRow = ({ 
  venue, 
  index, 
  animationState,
  isLoading, 
  isButtonEnabled,
  onAction,
  hasAcceptedQuote,
  allQuotesRejected,
  // NEW props
  isTrumidRfq,
  venues,
  actionColumnHidden,
  rfqStatus,
  rfqInquiryType,
  protocolName,
  // NEW prop
  canAct = true,
}) => {
  // unified per-row button enablement; inject enhanced protocol context when applicable
  const effectiveIsButtonEnabled = React.useCallback((status, buttonType) => {
    return isTrumidRfq
      ? isButtonEnabled(status, buttonType, venue, venues, protocolName, rfqStatus, rfqInquiryType)
      : isButtonEnabled(status, buttonType);
  }, [isTrumidRfq, isButtonEnabled, venue, venues, protocolName, rfqStatus, rfqInquiryType]);

  return (
    <TableRow
      sx={{
        height: ROW_HEIGHT,
        backgroundColor: tokens.colors.defaultGridColor,
        opacity: animationState === "entered" ? 1 : 0,
        transform:
          animationState === "entered"
            ? "translateY(0)"
            : `translateY(${TRANSLATION_Y_OFFSET})`,
        transition: "opacity 0.3s ease, transform 0.3s ease",
        transitionDelay: `${CONNECTOR_TRANSITION_BASE_DELAY * index}s`,
        "&:hover": {
          backgroundColor: tokens.colors.defaultGridHoverColor,
        },
      }}
    >
      <TableCell
        sx={{
          color: tokens.colors.fontColour,
          fontSize: "0.875rem",
          textAlign: "left",
        }}
      >
        {venue.venue}
      </TableCell>
      <TableCell
        sx={{
          color: tokens.colors.fontColour,
          fontSize: "0.875rem",
          textAlign: "right",
        }}
      >
        {venue.qty?.toLocaleString() || "--"}
      </TableCell>
      {/* Price: highlight strictly based on isBestPrice */}
      <TableCell
        className={venue.isBestPrice ? 'best-price-cell' : ''}
        sx={{
          color: venue.isBestPrice ? `${tokens.palette.primaryA90} !important` : tokens.colors.fontColour,
          fontSize: "0.875rem",
          textAlign: "right",
          fontWeight: venue.isBestPrice ? 700 : 400,
          '&.best-price-cell': {
            color: venue.isBestPrice ? `${tokens.palette.primaryA90} !important` : tokens.colors.fontColour,
            '& *': {
              color: venue.isBestPrice ? `${tokens.palette.primaryA90} !important` : tokens.colors.fontColour,
            }
          }
        }}
      >
        {venue.price || "--"}
      </TableCell>
      {/* <TableCell
        sx={{
          color: tokens.colors.fontColour,
          fontSize: "0.875rem",
          textAlign: "center",
        }}
      >
        {venue.quoteTTL || "--"}
      </TableCell> */}
      <TableCell
        sx={{
          color: tokens.colors.fontColour,
          fontSize: "0.875rem",
          textAlign: "right",
        }}
      >
        {venue.counterPrice || "--"}
      </TableCell>
      <TableCell
        sx={{
          color: tokens.colors.fontColour,
          fontSize: "0.875rem",
          textAlign: "right",
        }}
      >
        {venue.acceptedPrice || "--"}
      </TableCell>

      {/* Wire Time column - always present in header; show '---' when undefined */}
      <TableCell
        sx={{
          color: tokens.colors.fontColour,
          fontSize: "0.875rem",
          textAlign: "right",
        }}
      >
        {(venue.quoteExpiryDtTime === undefined ||
          venue.quoteExpiryDtTime === null ||
          (typeof venue.quoteExpiryDtTime === "string" && venue.quoteExpiryDtTime.trim() === ""))
          ? "N/A"
          : venue.quoteExpiryDtTime}
      </TableCell>

      <TableCell
        sx={{
          color: tokens.colors.fontColour,
          fontSize: "0.875rem",
          textAlign: "left",
        }}
      >
        {venue.displayQuoteStatus || venue.status || "--"}
      </TableCell>

      {!actionColumnHidden && (
        <TableCell
          sx={{
            textAlign: "center",
          }}
        >
          {canAct && (
            <RfqActionButtons
              venue={venue}
              isLoading={isLoading}
              animationState={animationState}
              onAction={onAction}
              isButtonEnabled={effectiveIsButtonEnabled}
              isTrumidRfq={isTrumidRfq}
            />
          )}
        </TableCell>
      )}
    </TableRow>
  );
};

export default RfqTableRow;
